"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoState = void 0;
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
var VideoState;
(function (VideoState) {
    VideoState["INCOMPLETE"] = "INCOMPLETE";
    VideoState["COMPLETE"] = "COMPLETE";
})(VideoState = exports.VideoState || (exports.VideoState = {}));
class Video extends base_model_1.default {
    constructor(data = {
        id: null,
        name: null,
        url: null,
        duration: null,
        order: null,
        state: null,
        next: null,
        previous: null,
    }) {
        super(data);
        this.VideoState = {
            INCOMPLETE: 'INCOMPLETE',
            COMPLETE: 'COMPLETE',
        };
        // Lowercase class name for normalization because JSCore uses base class name
        this.type = 'videos';
        this.name = defaults_1.defaultString(data.name);
        this.url = defaults_1.defaultString(data.url);
        this.duration = defaults_1.defaultString(data.duration);
        this.order = defaults_1.defaultNumber(data.order);
        this.state = defaults_1.defaultEnum(data.state, VideoState);
        this.next = defaults_1.defaultString(data.next);
        this.previous = defaults_1.defaultString(data.previous);
    }
    get hasUrl() {
        return this.url.length > 0;
    }
    get durationInfo() {
        let hours = 0;
        let minutes = 0;
        let seconds = 0;
        if (this.duration.length) {
            const splits = this.duration.split(":");
            if (splits.length) {
                if (splits.length === 1) {
                    seconds = parseInt(splits[0], 10);
                }
                else if (splits.length === 2) {
                    minutes = parseInt(splits[0], 10);
                    seconds = parseInt(splits[1], 10);
                }
                else if (splits.length === 3) {
                    hours = parseInt(splits[0], 10);
                    minutes = parseInt(splits[1], 10);
                    seconds = parseInt(splits[2], 10);
                }
            }
        }
        return {
            hours, minutes, seconds,
        };
    }
    get completed() {
        return this.state === VideoState.COMPLETE;
    }
}
exports.default = Video;
